
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import classes from './MainFooter.module.css';

const MainFooter = () => {
    return (
        <Fragment>
            <div className="container-fluid">
                <footer className={classes.footer}>
                    <div className={classes.box}>
                        <span>© 2026 Invensoft Solutions. All rights reserved.</span>
                    </div>
                </footer>
            </div>
        </Fragment>
    );
}

export default MainFooter;